var _rect, _rect2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroceries(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#87B103"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(14 14)",
    fill: "#87B103"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.74 25.185C16.4535 22.3828 19.0758 20.17 21.7899 20.9239L23.4647 21.3892C23.8149 21.4865 24.1851 21.4865 24.5353 21.3892L26.2101 20.9239C28.9242 20.17 31.5465 22.3828 31.26 25.185L30.92 28.5087C30.6591 31.0599 28.5104 33 25.946 33H22.054C19.4896 33 17.3409 31.0599 17.08 28.5087L16.74 25.185Z",
    fill: "#87B103",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4584 17.0298C24.0711 15.9687 25.293 15.2494 26.9862 15.0492C27.6594 16.6157 27.6475 18.0337 27.0349 19.0948C26.6187 19.8155 25.9355 20.368 25.0126 20.7178C24.1636 21.0396 23.2098 20.489 23.064 19.5928C22.9055 18.6186 23.0423 17.7506 23.4584 17.0298Z",
    fill: "#87B103",
    stroke: "white",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroceries);
export default __webpack_public_path__ + "static/media/Groceries.ddbdace9e31a10ed4e0ace8543309b3e.svg";
export { ForwardRef as ReactComponent };